import { trpc } from '@/lib/trpc'

export interface StandaloneTask {
  id: string
  title: string
  notes: string | null
  url: string | null
  category: string | null
  estimatedMinutes: number | null
  contentBody: string | null
  createdAt: string
  updatedAt: string
}

/**
 * Hook to fetch standalone tasks (tasks not associated with any source)
 * Used by the StandaloneTasksWidget to display assignable tasks
 */
export function useStandaloneTasks() {
  const utils = trpc.useUtils()

  const { data, isLoading, error } = trpc.admin.content.listTasks.useQuery({
    standalone: true,
  })

  return {
    tasks: (data?.data as StandaloneTask[]) ?? [],
    loading: isLoading,
    error: error?.message ?? null,
    refresh: () => utils.admin.content.listTasks.invalidate(),
  }
}
